import { useCallback, useMemo, useState, useContext } from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Grid, Stack } from '@vapor/material'
import { useConfirm } from 'hic-components'
import { useTranslation } from 'react-i18next'
import CheckoutDocumentForm, { CreateCoParameter, UpdateCoParameter } from 'src/app/pages/accounting/documents/checkout-document/checkout-document-form'
import { useHotelDate } from 'src/app/hooks/context/context.hook'
import CheckInButton from '../reserved-resources-tab/check-in/check-in-button'
import { BillF, DepositF } from '../../types/reservation-detail.types'
import CheckOut from '../reserved-resources-tab/check-out/check-out'
import useCheckoutApi from '../reserved-resources-tab/check-out/check-out.api'
import TimeReservedResourcesGrid from './time-reserved-resource-grid/time-reserved-resource-grid'
import ReservationTimeNewDrawer from '../../../reservation-time-insert/reservation-time-new-drawer'
// import ReservationUpsertDrawer from '../../../reservation-group-upsert/reservation-group-upsert-drawer'
// import { faPrint } from '@fortawesome/pro-regular-svg-icons'
// import ReceptionReportViewer from 'src/app/components/report-viewer/reception/reception-report-viewer'
// import SelectDatePopover from 'src/app/components/select-date-popover/select-date-popover'
// import { compareDates } from 'src/utils/date'
// import ReservedResourcesBulkEditDialog from './reserved-resources-bulk-edit/reserved-resources-bulk-edit-dialog'
// import ReservedResourcesUpdateAction from './reserved-resources-update-actions/ReservedResourcesUpdateActions'
// import useInfoSnackBar from 'src/app/hooks/info-snack-bar/use-info-snack-bar'
// import RRBulkEditChargeCategoriesDrawer from './rr-bulk-edit-charge-categories/rr-bulk-edit-charge-categories-drawer'
// import { useDeleteReservedResourceMutation } from 'src/api/api.generated'
// import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
// import useSuccessSnackBar from 'src/app/hooks/success-snack-bar/use-success-snack-bar'
// import { useApolloClient } from '@apollo/client'
import { ReservationContext } from '../../context/reservation-context'
import DocumentReportViewer from 'src/app/components/report-viewer/documnent/document-report-viewer'

export type TimeReservedResourcesTabProps = {
  readOnly: boolean
  propertyId: string
  bills: BillF[]
  deposits: DepositF[]
  reservedResourceId?: string | null
  setLoading: (loading: boolean) => void
  refetchReservation: () => void
  unsavedChanges: (rrId: string | undefined) => void
}

export function TimeReservedResourcesTab(props: TimeReservedResourcesTabProps) {
  const { propertyId, bills, deposits, reservedResourceId, readOnly, setLoading, refetchReservation, unsavedChanges } = props
  const { t } = useTranslation()
  const [selectedRows, onSelectedRowsChange] = useState<string[]>([])
  const [newReservationOpenDrawer, setNewReservationOpenDrawer] = useState<string | undefined>()
  // const [newReservationGroupOpenDrawer, setNewReservationGroupOpenDrawer] = useState<string | undefined>()
  const [printDocumentId, setPrintDocumentId] = useState<string | null>(null)
  const [checkoutDocumentFormParams, setCheckoutDocumentFormParams] = useState<CreateCoParameter | UpdateCoParameter | null>(null)
  const [requestCheckout, setRequestCheckout] = useState<boolean>(false)
  const hotelDate = useHotelDate()
  const confirm = useConfirm()
  // const showError = useErrorSnackBar()
  // const showSuccess = useSuccessSnackBar()
  // const showInfo = useInfoSnackBar()
  const { validateCheckOut, checkOut } = useCheckoutApi()
  // const apolloClient = useApolloClient()

  const { reservation } = useContext(ReservationContext)

  const reservedResourcesIds = useMemo(() => {
    return reservation.reservedResources?.map((rr) => rr.id) ?? []
  }, [reservation.reservedResources])

  const onSuccessCheckoutDocument = useCallback(
    (closedBillsIds?: string[], noAskCheckoutConfirm?: boolean) => {
      // Aggiorno lo stato dei conti chiusi dal documeto.
      const closedBills = bills.map((b) => (closedBillsIds?.includes(b.id) ? { ...b, open: false } : { ...b }))

      // Controlliamo se tutti i conti della prenotazione sono chiusi
      if (validateCheckOut(reservation, closedBills, deposits, reservedResourcesIds).nextAction === 'CHECKOUT') {
        // Verificare se la prenotazion è nelle condizioni di check-out
        if (reservation.maxEnd && reservation.maxEnd <= hotelDate) {
          if (noAskCheckoutConfirm) {
            checkOut(reservation.tenantId, reservation.propertyId[0], reservation.id, reservedResourcesIds)
            setRequestCheckout(false)
          } else {
            confirm({
              title: t('pms.booking.reservation.check_out_confirm_title'),
              message: t('pms.booking.reservation.check_out_confirm_description'),
              confirmButtonText: t('commons.yes'),
              cancelButtonText: t('commons.no'),
              onConfirm: () => {
                checkOut(reservation.tenantId, reservation.propertyId[0], reservation.id, reservedResourcesIds)
              },
            })
          }
        }
      }
    },
    [reservation, bills, deposits, reservedResourcesIds, validateCheckOut, checkOut, confirm],
  )
  // //#region reception report drawer
  // const [openReceptionReport, setOpenReceptionReport] = useState<{ open: boolean; date: Date }>({ open: false, date: new Date() })
  // const closeReceptionReport = () => setOpenReceptionReport({ open: false, date: new Date() })
  // //#endregion

  // //#region select date popover
  // const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(null)
  // const handleOpenDateSelect = (event: React.MouseEvent<HTMLButtonElement>) => setPopoverAnchor(event.currentTarget)
  // const handleCloseDateSelect = () => setPopoverAnchor(null)

  // const resRatesStartDates = useMemo(() => reservation.reservedResources?.map((rr) => rr.start), [reservation])
  // const resRatesMinStartDate = useMemo(() => (resRatesStartDates ? new Date(Math.min(...resRatesStartDates.map((d) => d.getTime()))) : undefined), [resRatesStartDates])
  // const resRatesEndDates = useMemo(() => reservation.reservedResources?.map((rr) => rr.end), [reservation])
  // const resRatesMaxEndDate = useMemo(() => (resRatesEndDates ? new Date(Math.max(...resRatesEndDates.map((d) => d.getTime()))) : undefined), [resRatesEndDates])

  // const defaultDate = useMemo(() => {
  //   const today = new Date()
  //   if (resRatesMinStartDate && resRatesMaxEndDate) {
  //     if (compareDates(today, resRatesMinStartDate) < 0) return resRatesMinStartDate
  //     if (compareDates(resRatesMaxEndDate, today) < 0) return resRatesMaxEndDate
  //   }
  //   return new Date()
  // }, [resRatesMinStartDate, resRatesMaxEndDate])
  // //#endregion

  // //#region open reserved resources bulk edit
  // const [openRRBulkEdit, setOpenRRBulkEdit] = useState<ReservedResourceF[]>([])
  // const [openRRBulkEditCC, setOpenRRBulkEditCC] = useState<ReservedResourceF[]>([])
  // const [deleteReservedResourceMutation, { loading: deleteReservedResourcesLoading }] = useDeleteReservedResourceMutation()

  // const deleteRR = useCallback(async (reservedResourceId: string) => {
  //   return await deleteReservedResourceMutation({
  //     variables: {
  //       tenantId: tenantId,
  //       deleteReservedResourceId: reservedResourceId,
  //     },
  //   })
  // }, [])
  // //#endregion

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs="auto">
            <CheckInButton //
              readOnly={readOnly}
              propertyId={propertyId}
              reservation={reservation}
              selectedReservedResources={selectedRows}
              setLoading={setLoading}
              isTimeResource={true}
            />
          </Grid>
          <Grid item xs="auto">
            <CheckOut //
              readOnly={readOnly}
              reservation={reservation}
              bills={bills}
              deposits={deposits}
              checkOutReservedResourceIds={selectedRows}
              onCreateDocument={(params) => {
                setCheckoutDocumentFormParams(params)
                setRequestCheckout(true)
              }}
              isTimeResource={true}
            />
          </Grid>
          <Grid item xs />

          <Grid item xs="auto">
            <Button
              disabled={readOnly}
              variant="outlined"
              size="small"
              onClick={() => {
                setNewReservationOpenDrawer(reservation.id)
              }}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: 2 }} />
              <span style={{ marginLeft: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t('pms.booking.reservation.action.add_time_reserved_resource')}</span>
            </Button>
          </Grid>

          <Stack direction="row" display="flex" justifyContent="space-between">
            <Box sx={{ display: 'flex' }}>
              <Stack direction="row" spacing={1}></Stack>
            </Box>
            <Box></Box>
          </Stack>
        </Grid>

        {/* <CheckInAlert /> */}

        <Grid item xs={12}>
          <TimeReservedResourcesGrid //
            readOnly={readOnly}
            propertyId={propertyId}
            reservation={reservation}
            reservedResourceId={reservedResourceId}
            onSelectedRowsChange={onSelectedRowsChange}
            unsavedChanges={unsavedChanges}
          />
        </Grid>
      </Grid>
      {newReservationOpenDrawer !== undefined && (
        <ReservationTimeNewDrawer
          key={'newRt'}
          reservationId={newReservationOpenDrawer}
          open={newReservationOpenDrawer !== undefined}
          onCancel={() => setNewReservationOpenDrawer(undefined)}
          onConfirm={() => {
            setNewReservationOpenDrawer(undefined)
            refetchReservation()
          }}
          propertyId={propertyId}
        />
      )}

      {/*
      {newReservationGroupOpenDrawer !== undefined && (
        <ReservationUpsertDrawer
          open={newReservationGroupOpenDrawer !== undefined}
          reservedResourceId={newReservationGroupOpenDrawer}
          onCancel={() => setNewReservationGroupOpenDrawer(undefined)}
          onConfirm={() => {
            setNewReservationGroupOpenDrawer(undefined)
            refetchReservation()
          }}
          propertyId={propertyId}
        />
      )}
    */}
      {checkoutDocumentFormParams !== null && (
        <CheckoutDocumentForm //
          propertyId={propertyId}
          open={checkoutDocumentFormParams != null}
          onClose={() => {
            setCheckoutDocumentFormParams(null)
            setRequestCheckout(false)
          }}
          onSuccess={({ closedBillsIds, documentId }) => {
            onSuccessCheckoutDocument(closedBillsIds, requestCheckout)
            setPrintDocumentId(documentId)
          }}
          refetchQueries={['ReservationDetail']}
          onCreditNoteSuccess={() => {
            setCheckoutDocumentFormParams(null)
            setRequestCheckout(false)
          }}
          {...checkoutDocumentFormParams}
        />
      )}
      {printDocumentId && (
        <DocumentReportViewer
          open={printDocumentId !== null}
          setClose={() => {
            setPrintDocumentId(null)
          }}
          documentId={printDocumentId}
          propertyId={propertyId}
        />
      )}
      {/* <SelectDatePopover
        open={popoverAnchor}
        closePopover={handleCloseDateSelect}
        min={resRatesMinStartDate}
        max={resRatesMaxEndDate}
        defaultDate={defaultDate}
        onDateSelected={(date) => setOpenReceptionReport({ open: true, date })}
        confirmButtonTitle={t('pms.booking.reservation.action.reception_report_generate')}
      />

      {openReceptionReport.open && (
        <ReceptionReportViewer
          propertyId={propertyId}
          day={openReceptionReport.date}
          open={openReceptionReport.open}
          setClose={closeReceptionReport}
          filter={{ group: reservation.group ?? undefined }}
        />
      )}

      {openRRBulkEdit.length > 0 && (
        <ReservedResourcesBulkEditDialog
          propertyId={propertyId}
          open={openRRBulkEdit.length > 0}
          onClose={() => setOpenRRBulkEdit([])}
          reservedResources={openRRBulkEdit}
          onSuccess={async () => {
            setOpenRRBulkEdit([])
          }}
        />
      )}
      {openRRBulkEditCC.length > 0 && (
        <RRBulkEditChargeCategoriesDrawer
          reservation={{
            groupName: reservation.group ?? undefined,
            start: reservation.minStart,
            end: reservation.maxEnd,
          }}
          propertyId={propertyId}
          open={openRRBulkEditCC.length > 0}
          onClose={() => setOpenRRBulkEditCC([])}
          reservedResources={openRRBulkEditCC}
          onSuccess={async () => {
            setOpenRRBulkEditCC([])
          }}
        />
      )} */}
    </>
  )
}
